import React from "react";
import { Link } from "react-router-dom";
import logo1_contrasted from "../../assets/logo1_contrasted.png";

function NavbarForOnboardingForm() {
  // const navigate = useNavigate();

  return (
    <>
      {/* Navbar Code */}
      <nav
        className="navbar navbar-expand-lg sticky-top"
        style={{ backgroundColor: "#008cba" }}
      >
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logo1_contrasted} alt="logo" className="logo1" />
            <span className="ms-2 web-name text-white fw-bold">Screenify</span>
          </Link>
        </div>
      </nav>
    </>
  );
}

export default NavbarForOnboardingForm;
